
import XHeader from 'vux/src/components/x-header/index.vue'

import Group from 'vux/src/components/group/index.vue'

import Cell from 'vux/src/components/cell/index.vue'

import XButton from 'vux/src/components/x-button/index.vue'

import Divider from 'vux/src/components/divider/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
components: {
XHeader,
Group,
Cell,
XButton,
Divider,
InfiniteLoading
},
props:['cateId'],
data() {
return {

balanceList: [],

currentPage: 1,
}
},
filters: {
cateName(value) {
switch (value) {
case 6:
return '护眼水';
case 7:
return '护肤水';
case 9:
return '体验装';
}
}
},
methods: {
getLink(log){
if(log.order_id === 0)
return  false;
console.log(log);
if (log.type === 1) {
return  '/uc/orderDetail/'+ log.order_id;
}else{
return  '/uc/stockDetail/'+ log.order_id;
}
return  false;
},
infiniteHandler($state) {
const url = `${this.tianYiWebUrl}/wechat/uc/logPromiseBalance`
this.$http.get(url, {params: {page: this.currentPage,cateId:this.cateId  }}).then(r => {
const res = r.data
console.log(res)
if (res.code === 200) {
this.balanceList = [...this.balanceList, ...res.data.data]
if (res.data.total > res.data.per_page * res.data.current_page) {
this.currentPage++
$state.loaded()
} else {
$state.complete();
}

this.btnShowLoading = false
}
})
}
},
created: function () {
document.title = '我的库存'
},
};



// WEBPACK FOOTER //
// ./src/components/uc/PromiseBalanceList.vue